import React, { useEffect, useState } from "react";
import { FaGlobe, FaClock, FaMoneyBill, FaMobileAlt, FaTimes } from "react-icons/fa";
import Axios from "axios";
import { HOST_URL } from "./api/Api";
import ReactTelInput from "react-telephone-input";
import flags from "./assets/img/flags.png";
import styles from "./InternationalPopup.module.css";

const InternationalPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [timezones, setTimezones] = useState([]);

  const [timezone, setTimezone] = useState("");
  const [profileTimezoneOffset, setProfileTimezoneOffset] = useState(""); 

  const [currency, setCurrency] = useState("");
  const [mobile, setMobile] = useState("");
  const [phone, setPhone] = useState("");
    const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const [country, setCountry] = useState(""); 
  const [isCurrencyDisabled, setIsCurrencyDisabled] = useState(false);
  const [showCurrencyInput, setShowCurrencyInput] = useState(true);


  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;

  useEffect(() => {

    const saved = localStorage.getItem("popupSubmitted");
    if (saved === "true") return;


    fetch("http://ip-api.com/json/")
      .then((res) => res.json())
      .then((data) => {
        if (data.countryCode && data.countryCode !== "IN") {
        setShowPopup(true); 
      }
      })
      .catch((err) => console.error("Error fetching IP info:", err));

    const fetchProfileData = async () => {
      try {
        const response = await Axios.post(`${HOST_URL}/profile.php`, {
          user_id: userId,
          token: userToken,
          method: "retrieve",
        });

        if (response.data.success && response.data.data?.length > 0) {
          const userData = response.data.data[0];
          // setTimezone(userData.time_zone || "");
          setTimezone(userData.time_zone || "");
          setProfileTimezoneOffset(userData.time_zone_value || "");
          setCurrency(userData.country_currency || "");
          setCountry(userData.country || "IN");

        } else {
          console.error("Unexpected profile API response:", response.data);
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchProfileData();
  }, []);

  useEffect(() => {
    // const saved = localStorage.getItem("popupSubmitted");
    // if (saved === "true") return;

    const login = JSON.parse(localStorage.getItem("login") || "{}");
    const userId = login?.user?.userId;
    const userToken = login?.token;

    if (!userId || !userToken) {
      console.error("User not logged in or missing token");
      return;
    }

    const fetchCurrency = async () => {
      try {
        const response = await Axios.post(`${HOST_URL}/profile.php`, {
          user_id: userId,
          token: userToken,
          method: "currency_update_check",
        });
        if (response.data.data === 0) {
          setShowCurrencyInput(true);
          setIsCurrencyDisabled(false);
        }
        else {
          setShowCurrencyInput(true);
          setIsCurrencyDisabled(true);
        }
      }
      catch {
        console.error("Error fetching currency data");
      }
    }

    const fetchTimezones = async () => {
      try {
        const res = await fetch("https://napi.authkey.io/api/v1/Timezone", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
            user_id: userId,
          },
          body: JSON.stringify({
            user_id: userId,   // ✅ API expects inside body
            method: "fetchTimezone"
          }),
        });

        const data = await res.json();

        if (data.success && Array.isArray(data.data)) {
          setTimezones(data.data);
        } else {
          console.error("Unexpected API format:", data);
        }
      } catch (err) {
        console.error("Error fetching timezones:", err);
      }
    };

    fetchTimezones();
    fetchCurrency();
  }, []);

  const handleTimezoneChange = (e) => {
  const selectedTz = e.target.value;
  setTimezone(selectedTz);

  // Find the offset for the selected timezone
  const tzObj = timezones.find((tz) => tz.Timezone === selectedTz);
  if (tzObj) {
    setProfileTimezoneOffset(tzObj["UTC Offset"]);
  }
};


const handleSubmit = async () => {
  try {
    const selectedTzObj = timezones.find((tz) => tz.Timezone === timezone);
    const utcOffset = selectedTzObj ? selectedTzObj["UTC Offset"] : "";

    const response = await Axios.post(`${HOST_URL}/profile.php`, {
      user_id: userId,
      token: userToken,
      method: "currency_update",
      currency: currency,
      timezone_title: timezone,
      timezone: utcOffset,
      mobile: mobile || "", 
    });

    if (response?.data) {
      setMessage(response.data.message || JSON.stringify(response.data));
      setStatus(response.data.success ? "success" : "error");

      if (response.data.success) {
          localStorage.setItem("popupSubmitted", "true");
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
      }
    }
  } catch (error) {
    setMessage("Network error. Please try again later.");
    setStatus("error");
  }
};

  if (!showPopup) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>

        <button
          className={styles.closeBtn}
          onClick={() => setShowPopup(false)}
          aria-label="Close"
        >
          <FaTimes />
        </button>

        <FaGlobe size={36} className={styles.headerIcon} />
        <h2 className={styles.title}>Welcome to Authkey!</h2>
        <p className={styles.subtitle}>
          We’re excited to have you here! Please share a few details to make your journey with Authkey even better.
        </p>

{status && (
  <div
    className={`alert ${
      status === "success" ? "alert-success" : "alert-danger"
    } alert-dismissible`}
    role="alert"
  >
    <button
      type="button"
      className="close"
      onClick={() => setStatus("")}
      aria-label="Close"
    >
      <span aria-hidden="true">×</span>
    </button>
    <div>{message}</div>
  </div>
)}

        <div className={styles.formGroup}>
          <label className={styles.label}>
            <FaClock /> Select Timezone
          </label>
        <select
  value={timezone}
  onChange={handleTimezoneChange}
  className={styles.select}
>
  <option value="">-- Select Timezone --</option>
  {timezones.length > 0 ? (
    timezones.map((tz, i) => (
      <option key={i} value={tz.Timezone}>
        {tz.Timezone} ({tz["UTC Offset"]})
      </option>
    ))
  ) : (
    <option disabled>Loading...</option>
  )}
</select>

        </div>

        {showCurrencyInput && (
          <div className={styles.formGroup}>
            <label className={styles.label}>
              <FaMoneyBill /> Currency
            </label>
            <select
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              className={styles.select}
              disabled={isCurrencyDisabled} // disable based on state
            >
              <option value={currency}>{currency}</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
            </select>
            {isCurrencyDisabled && (
              <small style={{ color: "blue", fontSize: "12px", marginTop: "2px", display: "block" }}>
                Recharge already exists. Please contact our customer support to change the currency.
              </small>
            )}
          </div>
        )}



        {/* <div className={styles.formGroup}>
          <label className={styles.label}>
            <FaMobileAlt /> Mobile Number (optional)
          </label>
          <input
            type="text"
            placeholder="Enter mobile number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            className={styles.input}
          />
        </div> */}
        <div className={styles.formGroup}>
          <label className={styles.label}>Mobile Number (optional)</label>
          <div className="input-group">
            <div className="input-group-prepend ReactTelFullbox">
              <ReactTelInput
                defaultCountry={country.toLowerCase() || "in"}
                flagsImagePath={flags}
                value={mobile}
                onChange={(phoneNumber) => setMobile(phoneNumber)}

              />
            </div>
            <input
              type="number"
              className="form-control logininput"
              placeholder="Enter Mobile Number"
              onChange={(e) => setMobile(e.target.value)}
            />
          </div>
        </div>

        <button onClick={handleSubmit} className={styles.button}>
           Update
        </button>
      </div>
    </div>
  );
};

export default InternationalPopup;
